import MallField from "comps/MallField"
import MmuSkuItem from "comps/MmuSkuItem"
import useProductDetail from "hooks/useProductDetail"
import IconArrawUp from "icons/icon-arrow-up.svg"
import IconSpeed from "icons/icon-speed.svg"
import immer from "immer"
import { numberAdd } from "libs/compute"
import { AccountPeriodEnum, BillingPeriodEnum } from "libs/enums"
import { PageMallSkuDetail } from "libs/types"
import { getEnumLabel } from "libs/utils"
import numeral from "numeral"
import { useEffect, useState } from "react"
import { Button, Picker, Popup, Toast, Dialog } from "react-vant"
import AgreementDetailPopup from "@/comps/AgreementDetailPopup"
import {checkConcreteAtribute} from 'api/order';

type MmuSkuListPopupWithIconProps = {
  skuList: Array<MmuMallSku>
  showUsePart: boolean
  selectTradeAgreement: TradeAgreementInfo
  shopInfo: Record<string, string>
  skuDetail: PageMallSkuDetail
  selectAccountPeriod: DiscountByMethodInfo
  selectStation: Station
  station: Array<Station>
  source: string
  setSelectStation: (station: Station) => void
  setSkuList: (skuList: Array<MmuMallSku>) => void
}

export default function MmuSkuListPopupWithIcon({
  skuList,
  showUsePart,
  selectTradeAgreement,
  shopInfo,
  skuDetail,
  selectAccountPeriod,
  selectStation,
  station,
  source,
  setSelectStation,
  setSkuList,
}: MmuSkuListPopupWithIconProps) {
  const { handleCreate, loading, getTotalPrice } = useProductDetail()
  const [visible, setVisible] = useState<boolean>(false)
  const [agreementVisible, setAgreementVisible] = useState(false)
  const [agreementId, setAgreementId] = useState(null)
  const [visibleStation, setVisibleStation] = useState<boolean>(false)
  console.log("skuList", skuList)
  useEffect(() => {
    if (station?.length) {
      setSelectStation(station[0])
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [station])

  function getTotalShopQuantity() {
    const total = skuList.reduce(
      (acc, cur) => (acc = acc + cur.shopQuantity),
      0,
    )

    if (total) {
      return numeral(total).format("0.[0000]")
    } else {
      return ""
    }
  }

  function getAccountPeriodLabel() {
    if (selectAccountPeriod?.accountPeriod === AccountPeriodEnum.CUSTOM.value) {
      return getEnumLabel({
        enums: BillingPeriodEnum,
        value: selectAccountPeriod?.billingPeriod,
      })
    } else {
      return getEnumLabel({
        enums: AccountPeriodEnum,
        value: selectAccountPeriod?.accountPeriod,
      })
    }
  }

  function handleConfirmStation(val) {
    setSelectStation(val)
    setVisibleStation(false)
  }

  function handleChangeSku(index: number, arr) {
    const newSkuList = immer(skuList, (draft) => {
      arr.forEach(({ key, value }) => {
        draft[index][key] = value
      })
    })
    setSkuList(newSkuList)
  }

  function handleDel(index: number) {
    const newSkuList = immer(skuList, (draft) => {
      draft.splice(index, 1)
    })
    setSkuList(newSkuList)
  }

  function showPop() {
    if (getTotalShopQuantity()) {
      setVisible(true)
    } else {
      Toast.info("暂未加入商品")
    }
  }

  function handleToTradeDetail() {
    setAgreementId(selectTradeAgreement?.sysNo)
    setAgreementVisible(true)
  }

  const handleSubmit = () => {
    const skuSysNos = new Set(skuList.map((i) => i.sysNo))
    const inventoryInfo = []
    skuSysNos.forEach((skuSysNo) => {
      const skus = skuList.filter((sku) => sku.sysNo === skuSysNo)
      if (skus.length) {
        const allQuantity = skus.reduce((acc, item) => {
          return +numberAdd(+item.shopQuantity, +acc)
        }, 0)
        const curSku = skus[0]
        if (!!curSku.inventory && allQuantity > curSku.inventory) {
          inventoryInfo.push(
            `${curSku.name}库存不足，收货区域可售库存为${curSku.inventory}${curSku.unitName}`,
          )
        }
      }
    })
    skuList.forEach(sku => {
      if(sku.concreteFlag && ( !sku.pourLocation || sku.pourLocation.length === 0 )) {
        inventoryInfo.push(
          `还未填写浇筑部位`,
        )
      }
    })
    
    if (inventoryInfo.length) {
      Toast.info(inventoryInfo[0])
      return
    }
    const getCheckData = (sku) => {
      const attrs = ((sku.attributeList || []).concat(sku.mmuAttributeList || []))?.map(attr => ({
        attributeNo: attr.costCenterCode,
        attributeName: attr.attributeName,
        attributeValueList: attr.categoryAttributeValueList?.map(t => ({
          attributeValueNo: t.costCenterCode,
          attributeValueName: t.attributeValue,
        }))
      }))?.filter(item => item.attributeValueList?.length > 0)
      const data = {
        stationId: selectStation?.stationNo,
        attributeList: attrs
      }
      console.log('data... ', data)
      return data
    }
    console.log('check....222')
    Promise.all(skuList.map(sku => checkConcreteAtribute(getCheckData(sku)))).then(results => {  
        // results 是一个数组，包含了每个 checkUserExists 调用解决的结果  
        const wrongs = []
        results.forEach((item, i) => {
          if (item.code !== 200){ 
            wrongs.push(<div>第{i+1}条数据: {item.message}</div>)
          }
        })
        if (wrongs.length > 0) {
          Dialog.confirm({
            message: <>{wrongs}</>,
            confirmButtonText: '继续下单',
            cancelButtonText: '取消',
            onCancel: () => {
              return;
            },
            onConfirm: () => {
              handleCreate({
                skuList,
                selectTradeAgreement,
                shopInfo,
                skuDetail,
                selectAccountPeriod,
                selectStation,
                source,
              })
            }
          });
        } else {
          handleCreate({
            skuList,
            selectTradeAgreement,
            shopInfo,
            skuDetail,
            selectAccountPeriod,
            selectStation,
            source,
          })
        }
    })  
    .catch(error => {  
      // 如果任何一个 promise 失败了，这里的 catch 会被调用  
      console.error('Error:', error);  
    });

    
  }

  useEffect(() => {
    if (skuList.length === 0) {
      setVisible(false)
    }
  }, [skuList.length])

  return (
    <>
      <div className="listIcon" onClick={showPop}>
        <span className="icon">
          {getTotalShopQuantity() && (
            <span className="count">
              <span className="num">{getTotalShopQuantity()}</span>
            </span>
          )}

          <IconSpeed />
        </span>
        <p className="listIconName">
          <span>速采清单</span>
        </p>
      </div>
      <Popup
        visible={visible}
        position="bottom"
        closeable
        style={{ width: "100%", height: "85%", backgroundColor: "#f2f2f2" }}
        onClose={() => setVisible(false)}
        transition="simple-bottom-transition"
      >
        <div className="content">
          <div className="head">
            <span className="closeIcon" onClick={() => setVisible(false)}>
              <IconArrawUp />
            </span>
            快速采购清单
          </div>
          <div className="body">
            <div className="mt10">
              {selectTradeAgreement?.name ? (
                <MallField
                  label="交易规则"
                  value={selectTradeAgreement?.name}
                  readonly
                  rightIcon
                  onClick={handleToTradeDetail}
                />
              ) : null}
              {getAccountPeriodLabel() ? (
                <MallField
                  label="交易方式"
                  value={getAccountPeriodLabel()}
                  readonly
                />
              ) : null}

              {station?.length ? (
                <MallField
                  label="搅拌站"
                  value={selectStation?.name}
                  readonly
                  rightIcon
                  onClick={() => {
                    setVisibleStation(true)
                  }}
                />
              ) : null}
            </div>
            <div className="mt10">
              {skuList.map((sku, index) => (
                <MmuSkuItem
                  showUsePart={showUsePart}
                  selectTradeAgreement={selectTradeAgreement}
                  key={`${index}-${sku.usePart}-${sku.comment}-${sku.shopQuantity}`}
                  mmuSku={sku}
                  onChange={(arr) => {
                    handleChangeSku(index, arr)
                  }}
                  onDel={() => {
                    handleDel(index)
                  }}
                />
              ))}
            </div>
          </div>
          <div className="foot">
            <span className="total">
              总计：
              <span className="price">
                &yen;{getTotalPrice(skuList) || " --"}
              </span>
            </span>
            <Button
              disabled={!getTotalPrice(skuList)}
              round
              type="primary"
              size="normal"
              className="submitBtn"
              loading={loading.current}
              onClick={handleSubmit}
            >
              立即下单
            </Button>
          </div>
        </div>
      </Popup>
      <Popup
        visible={visibleStation}
        position="bottom"
        onClose={() => setVisibleStation(false)}
        round
        transition="simple-bottom-transition"
      >
        <Picker
          title="搅拌站"
          columns={station}
          defaultIndex={0}
          columnsFieldNames={{ text: "name" }}
          onConfirm={handleConfirmStation}
          onCancel={() => setVisibleStation(false)}
        />
      </Popup>
      <AgreementDetailPopup
        visible={agreementVisible}
        setVisible={setAgreementVisible}
        id={agreementId}
        role="purchaser"
      />
      <style jsx>{`
        .listIcon {
          width: 58px;
          height: 56px;
          padding-top: 13px;
          text-align: center;
          background-color: #fff;
          font-size: 0px;
        }
        .icon {
          display: inline-block;
          position: relative;
          height: 22px;
        }
        .count {
          display: flex;
          min-width: 20px;
          height: 20px;
          justify-content: center;
          align-items: center;
          border-radius: 10px;
          border: 2px solid #fff;
          background-color: #ea5604;
          padding: 0 4px;
          color: #fff;
          position: absolute;
          top: -12px;
          left: 11px;
        }
        .num {
          font-size: 12px;
          transform: scale(0.9);
          transform-origin: center;
          display: block;
        }
        .listIconName {
          margin-bottom: 0px;
        }
        .listIconName span {
          display: inline-block;
          font-size: 12px;
          transform: scale(0.83);
          transform-origin: center;
          color: #666666;
          font-weight: normal;
          white-space: nowrap;
        }
        .content {
          display: flex;
          flex-direction: column;
          overflow: hidden;
          height: 100%;
        }
        .head {
          height: 44px;
          line-height: 44px;
          text-align: center;
          font-size: 17px;
          color: #262626;
          font-weight: 500;
          border-bottom: 1px solid #eee;
          position: relative;
          background-color: #fff;
          flex: 0 0 auto;
        }
        .closeIcon {
          display: block;
          width: 20px;
          height: 20px;
          line-height: 20px;
          text-align: center;
          position: absolute;
          left: 10px;
          top: 11px;
          transform: rotate(-90deg);
        }
        .body {
          padding-bottom: 64px;
          flex: 1 1 auto;
          overflow: auto;
        }
        .item {
          height: 200px;
        }
        .foot {
          position: fixed;
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
          height: 54px;
          padding: 0 16px;
          background-color: #fff;
          left: 0;
          right: 0;
          bottom: 0;
          z-index: 9999;
          box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.1);
        }
        .mt10 {
          margin-top: 10px;
        }
        .total {
          flex: 1 1 auto;
          font-size: 14px;
          color: #373737;
        }
        .price {
          font-size: 15px;
          color: #ea5604;
          font-weight: 500;
        }
        .foot :global(.submitBtn) {
          width: 100px;
          height: 38px;
        }
      `}</style>
    </>
  )
}
